import gql from 'graphql-tag'

const GET_PERSONAS = gql`
  {
    personaAndPlan {
      persona
      plan
    }
  }
`
export default GET_PERSONAS
